import * as tslib_1 from "tslib";
import setCASMailboxOperation from 'owa-service/lib/operation/setCASMailboxOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export function setCASMailbox(activeSyncDebugLogging, activeSyncSuppressReadReceipt) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var request, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        Header: getJsonRequestHeader(),
                        Options: {
                            ActiveSyncDebugLogging: activeSyncDebugLogging,
                            ActiveSyncSuppressReadReceipt: activeSyncSuppressReadReceipt,
                        },
                    };
                    return [4 /*yield*/, setCASMailboxOperation(request)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
//# sourceMappingURL=setCASMailbox.js.map